import { Navigate, Outlet } from 'react-router-dom';
import { useEffect } from 'react';

import { useAuthStore } from '@/shared/auth/authStore';
import { useDevModeStore } from '@/shared/store/useDevModeStore';
import { PATH, HOME_PATH_BY_ROLE } from '@/shared/constants';

export default function AuthRoute({
  allowedRoles = [],
  fallbackPath = null,
  guestOnly = false,
}: {
  allowedRoles?: string[];
  fallbackPath?: string | null;
  guestOnly?: boolean;
}) {
  const userInfo = useAuthStore((state) => state.userInfo);
  const pendingNavigation = useAuthStore((state) => state.pendingNavigation);
  const setPendingNavigation = useAuthStore((state) => state.setPendingNavigation);
  const isDevMode = useDevModeStore((state) => state.isDevMode);

  const isLoggedIn = userInfo.userRole !== '';
  const homePath = (userInfo.userRole && HOME_PATH_BY_ROLE[userInfo.userRole]) ?? PATH.AUTH.SIGNIN;
  const defaultRedirect = fallbackPath ?? homePath;

  useEffect(() => () => setPendingNavigation(null), [setPendingNavigation]);

  const isDev = import.meta.env.VITE_ENVIRONMENT === 'development' || import.meta.env.VITE_ENVIRONMENT === 'local';
  if (isDevMode && isDev) return <Outlet />;

  if (!guestOnly && allowedRoles.length === 0) return <Outlet />;

  if (guestOnly && isLoggedIn) {
    return <Navigate to={pendingNavigation ?? homePath} replace />;
  }

  if (allowedRoles.length > 0 && !allowedRoles.includes(userInfo.userRole ?? '')) {
    return <Navigate to={isLoggedIn ? defaultRedirect : PATH.AUTH.SIGNIN} replace />;
  }

  return <Outlet />;
}
